import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue";
import _imports_0 from '../../assets/image/sm.png';
const _hoisted_1 = {
  class: "news"
};
const _hoisted_2 = {
  class: "news_content"
};
import { ref, onMounted, onUnmounted, reactive } from 'vue';
import { useRouter } from 'vue-router';
import Index from '../my/index.vue';
// const list = ref([]);

export default {
  __name: 'index',
  setup(__props) {
    const list = [{
      text: "教育部部署做好2026年普通高校招生工作",
      time: "2026-01-22"
    }, {
      text: "卓越导向，面向未来——《卓越工程师教育认证标准》解读",
      time: "2025-12-12"
    }, {
      text: "教育部部署做好2026年普通高校部分特殊类型招生工作",
      time: "2025-11-03"
    }, {
      text: "2026年高校部分特殊类型招生工作答记者问",
      time: "2025-11-03"
    }, {
      text: "教育部等六部门印发《县域普通高中振兴行动计划》",
      time: "2025-09-28"
    }, {
      text: "教育部基础教育司负责人就《县域普通高中振兴行动计划》答记者问",
      time: "2025-09-28"
    }, {
      text: "国新办举行“高质量完成‘十四五’规划”系列主题新闻发布会",
      time: "2025-09-24"
    }, {
      text: "中央教育工作领导小组印发《高等教育学科专业设置调整优化行动方案（2025—2027年）》",
      time: "2025-08-28"
    }, {
      text: "全国学生资助管理中心发布预警警惕“助学贷款办理”骗局",
      time: "2025-08-19"
    }, {
      text: "全国高等学校名单",
      time: "2025-06-27"
    }, {
      text: "2024年全国教育事业发展统计公报",
      time: "2025-06-12"
    }, {
      text: "怀进鹏通过国家教育考试指挥平台视频调度全国高考组织工作",
      time: "2025-06-07"
    }, {
      text: "明天开考！教育部发布特别提醒",
      time: "2025-06-06"
    }, {
      text: "教育部发布2025年高考十问十答",
      time: "2025-06-03"
    }, {
      text: "教育部和各省（区、市）开通2025年高考举报电话",
      time: "2025-06-03"
    }, {
      text: "教育部会同中央网信办、公安部联合查处涉高考违法有害信息",
      time: "2025-05-30"
    }, {
      text: "坚持底线思维 筑牢安全防线 教育部会同有关部门全力保障2025年高考安全",
      time: "2025-05-28"
    }, {
      text: "教育部部署开展“2025高考护航行动”",
      time: "2025-05-26"
    }, {
      text: "2025年全国普通高校招生考试安全工作视频会议召开",
      time: "2025-04-26"
    }, {
      text: "高校学科专业设置调整优化工作推进会召开",
      time: "2025-04-25"
    }];
    onMounted(() => {});
    onUnmounted(() => {});
    return (_ctx, _cache) => {
      const _component_van_nav_bar = _resolveComponent("van-nav-bar");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_nav_bar, {
        title: "新闻"
      }, {
        right: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createElementVNode("img", {
          src: _imports_0,
          style: {
            "width": "20px"
          }
        }, null, -1)]))]),
        _: 1
      }), _createElementVNode("div", _hoisted_2, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(list, (item, index) => {
        return _createElementVNode("div", {
          class: "news_content_item",
          key: index
        }, [_createElementVNode("p", null, _toDisplayString(item.text), 1), _createElementVNode("span", null, _toDisplayString(item.time), 1)]);
      }), 64))])]);
    };
  }
};